import React, { useState } from 'react';
import { apiService } from '../services/api';
import { useApi, useMutation } from '../hooks/useApi';
import logger from '../utils/logger';
import { Tags, PlusCircle, Pencil, Trash2 } from 'lucide-react';

function LlojetHarxhimeve() {
  const [emri, setEmri] = useState('');
  const [editId, setEditId] = useState(null);

  const { data: llojetData, execute: refetchLlojet } = useApi(
    () => apiService.get('/lloj-harxhimi'),
    [],
    { immediate: true, showNotifications: false }
  );

  const llojet = Array.isArray(llojetData) ? llojetData : (llojetData?.data || []);

  const { mutate: saveLloj, loading: saving } = useMutation(
    async (emri) => {
      if (editId) {
        return await apiService.put(`/lloj-harxhimi/${editId}`, { emri });
      } else {
        return await apiService.post('/lloj-harxhimi', { emri });
      }
    },
    {
      successMessage: editId ? 'Lloji u përditësua me sukses!' : 'Lloji u shtua me sukses!',
      onSuccess: () => {
        setEmri('');
        setEditId(null);
        refetchLlojet();
      }
    }
  );

  const { mutate: deleteLloj } = useMutation(
    async (id) => {
      return await apiService.delete(`/lloj-harxhimi/${id}`);
    },
    {
      successMessage: 'Lloji u fshi me sukses!',
      onSuccess: () => {
        refetchLlojet();
      }
    }
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    saveLloj(emri);
  };

  const handleEdit = (item) => {
    setEditId(item.id);
    setEmri(item.emri);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('A je i sigurt që dëshiron të fshish këtë lloj?')) return;
    deleteLloj(id);
  };

  return (
    <div className="w-full animate-fade-in">
      <h2 className="text-3xl md:text-4xl font-bold mb-8 text-gradient-logo flex items-center gap-3 animate-slide-down">
        <div className="p-2 bg-primary-100 dark:bg-primary-900/30 rounded-lg">
          <Tags size={32} className="text-primary-600 dark:text-primary-400" />
        </div>
        Llojet e Harxhimeve
      </h2>

      <form onSubmit={handleSubmit} className="card-premium p-6 mb-8 flex gap-4">
        <input
          type="text"
          value={emri}
          onChange={(e) => setEmri(e.target.value)}
          placeholder="Shkruaj llojin (p.sh. Qira)"
          className="input-premium flex-1"
          required
        />
        <button
          type="submit"
          disabled={saving}
          className="btn-primary flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <PlusCircle size={18} />
          {saving ? 'Po ruhet...' : (editId ? 'Përditëso' : 'Shto')}
        </button>
      </form>

      <div className="card-premium overflow-hidden">
        <table className="table-premium">
          <thead>
            <tr>
              <th>#</th>
              <th>Tipi</th>
              <th>Veprime</th>
            </tr>
          </thead>
          <tbody>
            {llojet.length === 0 ? (
              <tr>
                <td colSpan="3" className="text-center py-8 text-gray-500 dark:text-gray-400">
                  Nuk ka lloje të regjistruar
                </td>
              </tr>
            ) : (
              llojet.map((l, i) => (
                <tr key={l.id}>
                  <td>{i + 1}</td>
                  <td className="font-medium">{l.emri}</td>
                  <td className="space-x-2">
                    <button onClick={() => handleEdit(l)} className="text-secondary-600 dark:text-secondary-400 hover:text-secondary-800 dark:hover:text-secondary-300 inline-flex items-center gap-1 transition-colors">
                      <Pencil size={16} /> Edito
                    </button>
                    <button onClick={() => handleDelete(l.id)} className="text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300 inline-flex items-center gap-1 transition-colors">
                      <Trash2 size={16} /> Fshi
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default LlojetHarxhimeve;
